<template>
    <div class="section-stream-description" :class="color">
        <layout-contained :class="padding">
            <client-only>
                <content-subheading
                    v-if="subheading"
                    :heading="subheading"
                    headingComponent="h3"
                    headingColor="text-zinc-400"
                    marginBottom="mb-4"
                ></content-subheading>
            </client-only>
            <content-heading
                v-if="heading"
                :class="content ? 'mb-4' : ''"
                :heading="heading"
                :headingColor="headingColor"
                :headingComponent="headingComponent"
                :textCentered="textCentered"
            ></content-heading>
            <content-text
                v-if="content"
                :html="content"
                :contentColor="contentColor"
                :textCentered="textCentered"
            ></content-text>
            <div v-if="chaptersByDay?.length && stream?.stream_status !== 'past'">
                <div class="mt-5" v-for="date in chaptersByDay" :key="date.day">
                    <content-subheading :heading="date.day" headingColor="text-zinc-300"></content-subheading>
                    <ul class="text-zinc-400 mt-2 xl:mt-3 space-y-2 xl:space-y-3">
                        <li
                            v-for="chapter in date.chapters"
                            :key="chapter.id_stream_chapter"
                            class="grid grid-cols-12 gap-2 sm:text-lg"
                        >
                            <span class="col-span-3 sm:col-span-2 xl:col-span-1">
                                {{ chapter.stream_chapter_starts_short_time }}
                            </span>
                            <span class="col-span-9 sm:col-span-10 xl:col-span-11">
                                {{ chapter.stream_chapter_title }}
                            </span>
                        </li>
                    </ul>
                </div>
                <div class="text-zinc-300 mt-7 text-base italic">All times displayed in your local time zone</div>
            </div>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'SectionStreamDescription',
    props: {
        stream: {
            required: false,
            type: Object,
            default() {
                return {};
            },
        },
        chaptersByDay: {
            required: false,
            type: Array,
            default() {
                return [];
            },
        },
        error: {
            required: false,
            type: String,
            default: null,
        },
        padding: {
            required: false,
            default: 'pt-6 pb-12',
            type: String,
        },
        color: {
            required: false,
            type: String,
            default: 'bg-zinc-900',
        },
        contentColor: {
            required: false,
            type: String,
            default: 'text-zinc-400',
        },
        headingColor: {
            required: false,
            type: String,
            default: 'text-zinc-200',
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'h1',
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
    computed: {
        heading() {
            if (this.error || this.stream?.stream_status === 'past') return 'Stream Ended';
            return this.stream?.stream_title;
        },
        subheading() {
            if (import.meta.server || this.stream?.stream_status === 'past') return null;
            if (this.stream?.stream_status === 'active') return 'Event in progress!';
            if (this.stream?.stream_starts_long_date) {
                return this.stream.stream_starts_long_date + ' at ' + this.stream.stream_starts_short_time;
            }
            return null;
        },
        content() {
            if (this.error || this.stream?.stream_status === 'past')
                return '<p>That stream has finished. Look out for the replays!</p>';
            return this.stream?.stream_description;
        },
    },
};
</script>
